// Single source of truth for years-of-experience across the site.
//
// The figure is computed from a fixed career-start date so it stays correct
// as time passes — no hardcoded "12+ years" to go stale. Anything that shows
// how long Jacques has been working (HomePage meta, the resume summary, prose
// tokens in markdown) should read from here. Two siblings mirror this anchor
// and must stay in sync: chat-api/api/chat.js (CAREER_START_YEAR) and
// scripts/build-chat-context.mjs.

export const CAREER_START_YEAR = 2013;
// September, zero-indexed to match Date.prototype.getMonth().
export const CAREER_START_MONTH = 8;

// Whole years of experience as of now, rounded down. Subtracting years alone
// overstates the figure between January and the September anniversary, so the
// month is checked too.
export function yearsOfExperience(now: Date = new Date()): number {
  const years = now.getFullYear() - CAREER_START_YEAR;
  return now.getMonth() < CAREER_START_MONTH ? years - 1 : years;
}

// Render-time token substitution for markdown/prose. Replaces {{yearsExperience}}
// (and the {{ years }}-spaced variant) with the current figure.
export function fillExperienceTokens(text: string): string {
  if (!text || typeof text !== 'string') return text;
  const years = String(yearsOfExperience());
  return text.replace(/\{\{\s*yearsExperience\s*\}\}/g, years);
}
